import axios from './axios-instance'

const BASEURL = '/jobs?'

export default {
  async getJobs() {
    return axios.get(BASEURL)
  },
  async getJobById(id) {
    return axios.get(`${BASEURL}id=${id}`)
  },
  async getJobsByQuery(searchTerm, matching, market = currentMarket) {
    // currentMarket is a serverside variable
    return axios.get(`${BASEURL}s=${searchTerm}&relevance=${matching}&markets=${market}`)
  },
  async getRecommendedJobs() {
    return axios.get(`${BASEURL}suggest=other-markets`)
  },
  async likeJob(id, action) {
    // action if true = unlike, else it is like
    // We need to move /like into the api, currently its outside of the api
    return axios.post(`${window.location.origin}/like`, {
      type: 'job',
      id,
      action: action ? 'like' : 'unlike',
    })
  },
  async assessIr35(id, params) {
    return axios.get(`/job/${id}/assess-ir35`, {
      params: {
        ratetype: params.ratetype,
        jobstart: params.jobstart,
        jobend: params.jobend,
      },
    })
  },
}
